const staging = {
  SITE_URL: 'https://jobswidget-staging.olegb.ru',
  API_URL: 'https://jobswidget-staging.olegb.ru/api/v1/',
  WEBSOCKET_URL: 'wss://jobswidget-staging.olegb.ru/ws',
};

export { staging as default };
